import React from 'react';
import { Button, Heading, Link, PinBL, PinCenter, PinTL, Text, } from '@marvelapp/ui';
export default function DownloadAppModal(_a) {
    var onClick = _a.onClick, projectID = _a.projectID;
    var urls = {
        appStore: 'https://itunes.apple.com/app/apple-store/id765801658?pt=96428809&ct=Prototype%20Open%20In%20App&mt=8',
        client: "mrvl://client?key=".concat(projectID),
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(PinTL, { alignItems: "center", display: "flex", justifyContent: "center", px: 4, py: 6, width: 1 },
            React.createElement(Heading, { color: "white", display: "inline-block", maxWidth: 340, textAlign: "center" }, "Download Marvel for iOS and play prototypes in full screen")),
        React.createElement(PinCenter, null,
            React.createElement(Button, { as: "a", href: urls.appStore, kind: "green", mb: 3, size: 3, width: 188 }, "Download Marvel"),
            React.createElement(Button, { as: "a", href: urls.client, kind: "ghostReversed", size: 3, width: 188 }, "I already have the app")),
        React.createElement(PinBL, { alignItems: "center", display: "flex", justifyContent: "center", px: 4, py: 6, width: 1 },
            React.createElement(Text, { color: "white", fontSize: 16, maxWidth: 220, textAlign: "center" },
                "Or",
                ' ',
                React.createElement(Link, { display: "inline", fontSize: 16, hasUnderline: true, kind: "notificationBar", onClick: onClick }, "play from your homescreen"),
                ' ',
                "without the app"))));
}
